import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Button from '@/components/Button/Button';

const DisableLinkConfirm = ({
  error,
  isDisabling,
  onConfirm,
  onCancel,
}: {
  error?: string | null;
  isDisabling: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => (
  <ConfirmBox
    role="alertdialog"
    aria-label="Confirm disabling this link"
  >
    <ConfirmTitle>
      <FormattedMessage
        id="disableLinkConfirmTitle"
        defaultMessage="Disable this link?"
      />
    </ConfirmTitle>
    <ConfirmText>
      <FormattedMessage
        id="disableLinkConfirmText"
        defaultMessage="Recipients who already have it will lose access immediately, including anyone with the basket open right now. This cannot be undone — sharing these files again means creating a new basket."
      />
    </ConfirmText>
    {error && <ConfirmError role="alert">{error}</ConfirmError>}
    <ConfirmActions>
      <DangerButton
        variant="contained"
        onClick={onConfirm}
        loading={isDisabling}
        disabled={isDisabling}
        aria-label="Yes, disable it"
      >
        <FormattedMessage
          id="disableLinkConfirmYes"
          defaultMessage="Yes, disable it"
        />
      </DangerButton>
      <Button
        variant="text"
        onClick={onCancel}
        disabled={isDisabling}
        aria-label="Keep the link"
      >
        <FormattedMessage
          id="disableLinkConfirmNo"
          defaultMessage="Keep the link"
        />
      </Button>
    </ConfirmActions>
  </ConfirmBox>
);

export const DangerButton = styled(Button)(({ theme }) => ({
  color: theme.palette.red600,
  borderColor: theme.palette.red300,
  '&.MuiButton-contained': {
    background: theme.palette.red600,
    color: theme.palette.white,
  },
}));

const ConfirmBox = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.5),
  borderRadius: theme.radii.sm,
  border: `1px solid ${theme.palette.red300}`,
  background: theme.palette.red50,
}));

const ConfirmTitle = styled('div')(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.red600,
  marginBottom: theme.spacing(0.5),
}));

const ConfirmText = styled('div')(({ theme }) => ({
  fontSize: 13,
  lineHeight: '18px',
  color: theme.palette.grey600,
}));

const ConfirmError = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: 13,
  fontWeight: 600,
  color: theme.palette.red600,
}));

const ConfirmActions = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(1.5),
}));

export default DisableLinkConfirm;
